import React from 'react';
import styled from 'styled-components';
import { Mutation } from 'react-apollo';
import {
  TableBody,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Typography,
  Switch,
} from '@material-ui/core';

import { FusePageCarded } from '../../../../@fuse';
import DoneIcon from '@material-ui/icons/Done';
import withUsersTable from './withUsersTable';
import { SET_ADMIN } from '../../../../graphql/mutation';
import { ROLES } from '../../../../graphql/query';
import { requireAuthentication } from '../../../../auth';

import PageHeader from './PageHeader';

const RoleButton = styled.div`
  border-radius: 50%;
  width: 25px;
  height: 25px;
  margin: auto;
  background-color: ${props =>
    props.active ? (props.role === 'SYSTEM_ADMIN' ? '#efd247' : '#039be5') : 'white'};
  border: 1px solid #727272;
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.role === 'SYSTEM_ADMIN' && !props.active && 'display: none;'};
`;

class UsersPage extends React.Component {
  setRole = (username, isAdmin, currentRole, setAdmin) => () => {
    if ((!currentRole && isAdmin) || (currentRole === 'ADMIN' && !isAdmin)) {
      return setAdmin({
        variables: {
          username,
          isAdmin,
        },
      });
    }
  };
  render() {
    const { loading, data } = this.props;
    if (loading) return null;

    const header = (
      <PageHeader onSearch={this.props.searchByName} disabled={this.props.onlyAdmin} />
    );
    const content = (
      <div className="text-center">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <Typography variant="subheading">Show Only Admin</Typography>
          <Switch checked={this.props.onlyAdmin} onChange={this.props.toggleOnlyAdmin} />
        </div>
        <Mutation mutation={SET_ADMIN} refetchQueries={[{ query: ROLES }]}>
          {setAdmin => (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Username</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Phone Number</TableCell>
                  <TableCell className="text-center">Role as Employee</TableCell>
                  <TableCell className="text-center">Role as Admin</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map(row => {
                  return (
                    <TableRow key={row.userName} hover className="h-64 cursor-pointer">
                      <TableCell component="th" scope="row">
                        {row.userName}
                      </TableCell>
                      <TableCell>{`${row.firstName || ''} ${row.lastName || ''}`}</TableCell>
                      <TableCell component="th" scope="row">
                        {row.emailAddress}
                      </TableCell>
                      <TableCell>{row.phones}</TableCell>
                      <TableCell>
                        <RoleButton
                          active={!this.props.admins[row.userName]}
                          role={this.props.admins[row.userName]}
                          onClick={this.setRole(
                            row.userName,
                            false,
                            this.props.admins[row.userName],
                            setAdmin
                          )}
                        >
                          <DoneIcon style={{ color: 'white', width: 17, height: 17 }} />
                        </RoleButton>
                      </TableCell>
                      <TableCell>
                        <RoleButton
                          active={this.props.admins[row.userName]}
                          role={this.props.admins[row.userName]}
                          onClick={this.setRole(
                            row.userName,
                            true,
                            this.props.admins[row.userName],
                            setAdmin
                          )}
                        >
                          <DoneIcon style={{ color: 'white', width: 17, height: 17 }} />
                        </RoleButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          )}
        </Mutation>
        {this.props.hasNextPage && (
          <Button
            className="m-12"
            color="secondary"
            variant="contained"
            onClick={this.props.loadNextPage}
          >
            Load more
          </Button>
        )}
      </div>
    );

    return <FusePageCarded header={header} content={content} innerScroll />;
  }
}

export default requireAuthentication(withUsersTable(UsersPage));



// WEBPACK FOOTER //
// ./src/main/content/project/users/index.js